import { Helmet } from 'react-helmet-async';

export const SITE_URL = (process.env.REACT_APP_SITE_URL || 'https://skyleaftravels.com').replace(/\/$/, '');
export const SITE_NAME = process.env.REACT_APP_NAME || 'Skyleaf Travels';
// Real hero photo (a frame from the owner's own Meghalaya footage) — used as
// the default OG/Twitter share image wherever a page doesn't supply its own.
const DEFAULT_IMAGE = `${SITE_URL}/images/hero-meghalaya.jpg`;

const DEFAULT_KEYWORDS = [
  'Northeast India tour packages',
  'Meghalaya tour package',
  'Arunachal Pradesh tour package',
  'Kaziranga safari booking',
  'Northeast India travel agency',
  'Guwahati tour operator',
  'Assam Meghalaya Arunachal itinerary'
];

export default function Seo({
  title,
  description,
  path = '/',
  image,
  type = 'website',
  noindex = false,
  jsonLd,
  keywords = []
}) {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} — Making Every Trip Worth the Story`;
  const url = `${SITE_URL}${path}`;
  const ogImage = image || DEFAULT_IMAGE;
  const jsonLdList = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];
  const keywordList = [...new Set([...keywords, ...DEFAULT_KEYWORDS])].join(', ');

  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      <meta name="keywords" content={keywordList} />
      <link rel="canonical" href={url} />
      <meta name="robots" content={noindex ? 'noindex, nofollow' : 'index, follow'} />

      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={ogImage} />

      {jsonLdList.map((schema, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(schema)}</script>
      ))}
    </Helmet>
  );
}

// Simple two-level breadcrumb (Home > this page) for top-level static pages.
// Detail pages with a real hierarchy (Home > Destinations > Meghalaya) build
// their own three-level list inline instead of using this helper.
export function simpleBreadcrumb(name, path) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Home', item: SITE_URL },
      { '@type': 'ListItem', position: 2, name, item: `${SITE_URL}${path}` }
    ]
  };
}
